  import apiService from "./apiService";

const inboundService = {
  getShipments: () => apiService.get("/api/v1/inbound/shipments"),
  postCreateShipment: (shipmentData) => apiService.post("/api/v1/inbound/shipments/create/", shipmentData),
  deleteEmbarque: (id) => apiService.delete(`api/v1/inbound/shipments/${id}`),
  updateEmbarque: (id, embarqueData) => apiService.put(`/api/v1/inbound/shipments/${id}`, embarqueData),
  

  getContenedores: () => apiService.get("/api/v1/inbound/contenedores"),
  postCreateContenedores: (contenedoresData) => apiService.post("/api/v1/inbound/contenedores/create/", contenedoresData),
  deleteContenedor: (id) => apiService.delete(`/api/v1/inbound/contenedores/${id}`),
  updateContenedor: (id, contenedorData) => apiService.put(`/api/v1/inbound/contenedores/${id}`, contenedorData),

  getStatusOfInbound: () => apiService.get("/api/v1/inbound/status_of_inbound"),
  postChangeStatus: (changeData) => apiService.post("/api/v1/inbound/shipments/change_status", changeData),

  getOrigins: () => apiService.get(`/api/v1/inbound/origins`),
  getNavieras: () => apiService.get(`/api/v1/inbound/navieras`),
  getPuertaVacios: () => apiService.get(`/api/v1/inbound/puerta_vacios`),
  
//   getUserById: (id) => apiService.get(`/users/${id}`),
//   createUser: (userData) => apiService.post("/users", userData),
//   updateUser: (id, userData) => apiService.put(`/users/${id}`, userData),
//   deleteUser: (id) => apiService.delete(`/users/${id}`),
};

export default inboundService;
